import module from 'usuario/module.js'
import template from './template.html'
import {orderBy} from 'lodash'
import moment from 'moment'

export class UsuarioVinculoComponent {
  idUsuario = null
  fecha = undefined

  constructor (UsuarioHistorialColaboradorService, $state) {
    this.UsuarioHistorialColaboradorService = UsuarioHistorialColaboradorService
    this.$state = $state
  }

  $onInit () {
    this.fecha = new Date()
    this.promise = this.UsuarioHistorialColaboradorService.get(this.fecha, this.idUsuario)
      .then((response) => {
        let datos = orderBy(response.data, ['fecha', 'tiempo'])
        datos.forEach((item) => (item.fecha = moment(item.fecha).format('LL')))
        this.datos = datos
      })
  }

  recargar () {
    this.datos = []
    this.buscando = true
    this.UsuarioHistorialColaboradorService.get(this.fecha, this.idUsuario)
      .then((response) => {
        let datos = orderBy(response.data, ['fecha', 'tiempo'])
        datos.forEach((item) => (item.fecha = moment(item.fecha).format('LL')))
        this.datos = datos

      })
      .finally(() => (this.buscando = false))
  }

  aumentar () {
    this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() + 1, this.fecha.getDate())
    this.recargar()
  }

  disminuir () {
    this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() - 1, this.fecha.getDate())
    this.recargar()
  }
}

module.component('usuarioHistorial', {
  controller: UsuarioVinculoComponent,
  template,
  bindings: {
    idUsuario: '<',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/historial/component.js